/** UK club: all sessions are advertised at this wall time (display only; not read from DB). */
export const SESSION_DISPLAY_TIME = "7:00 PM";
